var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _path35, _path36, _path37, _path38, _path39, _g2, _path40, _path41, _path42, _g3, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g4, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _ellipse, _path72, _path73;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLastImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 265,
    viewBox: "0 0 166 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.043 189.948L33.6167 170.983L102.797 175.234L104.062 189.948H30.043Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9441 59.2635C67.9441 59.2635 58.5833 56.1457 49.5092 59.2635C40.4352 62.3813 38.4792 72.0216 35.8982 77.9778C33.3171 83.9341 21.1914 108.318 21.1914 108.318L42.7441 115.973L33.6701 170.983C33.6701 170.983 48.4136 175.234 61.1717 176.94C73.9298 178.646 103.704 175.234 103.704 175.234V102.082L111.057 122.216C111.057 122.216 119.278 121.929 125.234 118.245C129.125 115.704 132.573 112.542 135.441 108.884C135.441 108.884 110.204 74.5732 108.233 69.7568C106.263 64.9403 94.6222 60.1165 89.8057 59.2635C84.9893 58.4105 67.9441 59.2635 67.9441 59.2635Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6934 115.973L49.4953 81.662L40.3477 113.098L42.5831 113.414",
    fill: "#699595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.651 102.082L102.32 89.4565L113.203 121.826L111.027 122.216L103.651 102.082Z",
    fill: "#699595"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9441 59.2635C67.9441 59.2635 58.5833 56.1457 49.5092 59.2635C40.4352 62.3813 38.4792 72.0216 35.8982 77.9778C33.3171 83.9341 21.1914 108.318 21.1914 108.318L42.7441 115.973L33.6701 170.983C33.6701 170.983 48.4136 175.234 61.1717 176.94C73.9298 178.646 103.704 175.234 103.704 175.234V102.082L111.057 122.216C111.057 122.216 119.278 121.929 125.234 118.245C129.125 115.704 132.573 112.542 135.441 108.884C135.441 108.884 110.204 74.5732 108.233 69.7568C106.263 64.9403 94.6222 60.1165 89.8057 59.2635C84.9893 58.4105 67.9441 59.2635 67.9441 59.2635Z",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6573 59.2783C62.9245 61.9086 61.2149 65.4242 60.8335 69.198C60.2673 75.441 58.8555 91.6037 58.8555 91.6037C58.8555 91.6037 65.3706 87.0666 67.9295 85.9269C70.4885 84.7871 75.0182 84.7945 75.0182 84.7945C75.0182 84.7945 81.5332 86.2137 83.2392 87.3461C84.9452 88.4785 92.5927 93.0229 92.5927 93.0229C92.5927 93.0229 90.8941 73.4556 89.1955 66.9111C87.4968 60.3666 82.9525 58.4032 75.5844 58.4032C68.2163 58.4032 65.6573 59.2783 65.6573 59.2783Z",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6573 58.1312C62.9245 60.7615 61.2149 64.2771 60.8335 68.0509C60.2673 74.2939 58.8555 90.4566 58.8555 90.4566C58.8555 90.4566 65.3706 85.9196 67.9295 84.7871C70.4885 83.6547 75.0182 83.6474 75.0182 83.6474C75.0182 83.6474 81.5332 85.0666 83.2392 86.199C84.9452 87.3314 92.5927 91.9126 92.5927 91.9126C92.5927 91.9126 90.8941 72.3452 89.1955 65.8228C87.4968 59.3004 82.9525 57.3149 75.5844 57.3149C68.2163 57.3149 65.6573 58.1312 65.6573 58.1312Z",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6445 62.1021C67.6445 62.1021 70.4829 82.515 73.8802 87.3388C77.2775 92.1626 82.7042 68.6245 82.7042 68.6245L67.6445 62.1021Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0931 70.8452C72.2404 73.7866 75.7112 75.794 78.9467 75.4558C79.6903 75.364 80.4121 75.1425 81.0791 74.8013C82.0424 71.3746 82.6748 68.6245 82.6748 68.6245L67.6445 62.1021C67.6445 62.1021 68.1887 66.0288 69.0931 70.8452Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4362 37.9976C57.4362 37.9976 54.5978 33.4606 52.6123 36.299C50.6269 39.1374 51.7667 42.8214 54.0315 46.5055C56.2964 50.1895 60.554 52.7411 61.3849 50.1822C62.2158 47.6232 57.4362 37.9976 57.4362 37.9976Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.034 39.983C101.034 39.983 103.872 35.446 105.858 38.2844C107.843 41.1228 106.711 44.7994 104.439 48.4908C102.166 52.1822 97.9162 54.7265 97.0853 52.1675C96.2544 49.6085 101.034 39.983 101.034 39.983Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7165 41.6817C57.7165 41.6817 60.5549 55.0133 64.5257 61.249C68.4965 67.4847 74.7322 73.4409 80.1222 72.8747C85.5122 72.3085 91.7479 62.6682 94.5789 57.2782C97.41 51.8882 99.969 48.7703 101.101 41.4022C102.234 34.0342 103.374 28.9015 100.822 24.3865C98.2703 19.8716 85.7917 13.0476 71.3276 14.7463C56.8635 16.4449 56.8708 25.519 57.1503 28.3574C57.4297 31.1958 56.8708 41.6817 57.7165 41.6817Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4462 47.4983C74.4462 48.9689 73.8799 50.1896 73.174 50.1896C72.4681 50.1896 71.8945 48.9836 71.8945 47.4983C71.8945 46.0129 72.4681 44.7996 73.174 44.7996C73.8799 44.7996 74.4462 46.0055 74.4462 47.4983Z",
    fill: "#699595"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6362 47.9908C86.5553 49.4614 85.9008 50.6527 85.2096 50.6086C84.5184 50.5644 84.0036 49.3364 84.0919 47.8511C84.1801 46.3657 84.8272 45.1891 85.5184 45.2333C86.2097 45.2774 86.7244 46.5054 86.6362 47.9908Z",
    fill: "#699595"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8633 55.2928C75.8633 55.2928 79.2679 59.8298 82.3857 54.7266",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0352 58.6974C73.0352 58.6974 75.8662 63.2345 80.3885 62.3741C84.9109 61.5138 86.911 57.2709 86.911 57.2709",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5195 41.9685C84.591 41.5816 85.7616 41.5671 86.8423 41.9274C87.923 42.2876 88.8507 43.0015 89.4758 43.9539",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5983 42.2478C73.5983 42.2478 68.7745 39.4168 66.7891 45.373",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4538 31.9605C64.4543 32.7148 66.7017 32.8048 68.7729 32.2138C70.7334 31.7003 72.3832 30.5337 73.3652 28.9667C73.3652 28.9667 73.075 33.2204 69.346 35.7272C65.6171 38.234 62.4538 39.2342 64.7537 40.4811C67.0536 41.728 74.5115 45.4947 84.5595 39.7342C94.6075 33.9738 95.2029 30.2071 95.2029 30.2071C95.2029 30.2071 91.7643 35.9675 94.6298 35.7207C97.4953 35.4739 99.5124 29.707 99.5124 29.707C99.5124 29.707 96.9297 36.4676 98.0759 38.7211C99.2221 40.9746 100.368 44.2348 100.368 44.2348C100.368 44.2348 97.7856 48.2418 99.5124 47.9885C101.239 47.7352 104.134 36.4676 104.134 36.4676C104.134 36.4676 107 28.4536 107 21.193C107 13.9323 102.854 7.82769 97.6888 5.32088C92.5234 2.81408 76.5434 -1.8878 66.0786 3.43104C57.2884 7.89912 52.4728 19.9396 53.0459 23.6998C53.619 27.46 57.348 42.228 57.348 42.228C57.348 42.228 59.0747 44.4816 59.6479 42.4813C59.97 40.9921 59.97 39.4635 59.6479 37.9743C60.6325 37.2406 61.4012 36.3116 61.8894 35.2653C62.3776 34.2189 62.5712 33.0856 62.4538 31.9605Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9144 115.973C50.9144 115.973 28.5161 109.45 24.2585 109.171C20.0009 108.891 19.942 114.318 21.9274 118.605C23.9128 122.892 35.3179 129.018 43.8258 129.304C52.3336 129.591 66.5109 132.135 66.5109 132.135C66.5109 132.135 70.4818 140.357 71.3274 142.063C72.173 143.769 75.0041 147.732 75.0041 147.732L92.0124 143.761C92.0124 143.761 82.9384 134.408 78.6881 128.731C74.4379 123.054 50.9144 115.973 50.9144 115.973Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M125.203 118.245C122.786 119.663 120.16 120.688 117.423 121.282L112.158 142.342C112.158 142.342 97.9804 134.408 95.9803 134.989C93.9802 135.569 89.7446 142.93 89.4579 144.908C89.1711 146.886 88.8916 149.166 90.0241 149.732C91.1565 150.298 101.65 153.137 103.922 153.137C105.469 153.09 107 152.803 108.459 152.284L108.738 149.732C108.738 149.732 112.143 152.57 114.695 150.865C116.263 149.785 117.529 148.322 118.371 146.614C118.371 146.614 132.835 119.679 133.968 116.274C134.865 113.576 135.049 111.598 134.1 110.465C131.521 113.47 128.525 116.09 125.203 118.245Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8534 137.239C96.8534 137.239 92.3164 146.313 92.3164 147.732C92.3252 148.613 92.518 149.482 92.8826 150.284",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8534 137.239C96.8534 137.239 92.3164 146.313 92.3164 147.732C92.3252 148.613 92.518 149.482 92.8826 150.284",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6793 138.379C99.6793 138.379 95.1422 148.298 97.1276 151.703L99.6793 138.379Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6793 138.379C99.6793 138.379 95.1422 148.298 97.1276 151.703",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.372 140.93C103.372 140.93 100.82 149.151 101.387 150.004C101.953 150.857 102.806 152.556 103.938 153.122",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.372 140.93C103.372 140.93 100.82 149.151 101.387 150.004C101.953 150.857 102.806 152.556 103.938 153.122",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3672 190.069H165.603",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1 190.069H7.87437",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6155 183.709C54.9584 181.915 51.1781 180.383 47.3033 179.126C41.7198 177.408 35.1319 178.981 34.9868 180.841C34.8416 182.701 35.8346 181.849 37.1369 183.866C38.4392 185.882 37.8511 190.595 39.7148 194.891C41.5785 199.188 47.1582 201.334 47.1582 201.334L58.6155 183.709Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.8929 187.864C54.8929 187.864 46.2999 182.422 41.2893 180.558C36.2786 178.695 35.9922 181.418 35.9922 181.418C36.8165 181.72 37.5239 182.276 38.0131 183.005C38.5022 183.734 38.748 184.6 38.7152 185.477C38.7152 188.693 40.323 195.353 44.23 196.728C48.1369 198.103 54.8929 187.864 54.8929 187.864Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M116.208 193.945C118.454 193.092 119.532 190.445 118.616 188.034C117.7 185.623 115.136 184.359 112.891 185.212C110.645 186.065 109.567 188.712 110.483 191.123C111.399 193.535 113.962 194.798 116.208 193.945Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6367 239.556L59.4564 254.015C59.5871 254.407 59.8379 254.747 60.1731 254.989C60.5083 255.23 60.9109 255.359 61.324 255.359H68.8361C69.2204 255.36 69.5964 255.247 69.9176 255.036C70.2387 254.825 70.4908 254.524 70.6425 254.171L74.0033 246.373",
    fill: "#699595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9845_20952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 239,
    width: 20,
    height: 17
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6328 239.556L59.4525 254.015C59.5832 254.407 59.834 254.747 60.1692 254.989C60.5044 255.23 60.907 255.359 61.32 255.359H68.8322C69.2165 255.36 69.5925 255.247 69.9137 255.036C70.2348 254.825 70.4868 254.524 70.6386 254.171L73.9994 246.373",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9845_20952)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M57.0508 239.556L61.0379 254.015C61.1134 254.378 61.306 254.706 61.5861 254.949C61.8662 255.192 62.2184 255.336 62.5885 255.359H68.8174C69.1595 255.341 69.4876 255.218 69.756 255.005C70.0243 254.792 70.2196 254.5 70.3145 254.171L73.1024 246.373",
    fill: "black"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6367 239.556L59.4564 254.015C59.5871 254.407 59.8379 254.747 60.1731 254.989C60.5083 255.23 60.9109 255.359 61.324 255.359H68.8361C69.2204 255.36 69.5964 255.247 69.9176 255.036C70.2387 254.825 70.4908 254.524 70.6425 254.171L74.0033 246.373",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8864 239.556L86.0705 254.015C85.9398 254.407 85.6891 254.747 85.3539 254.989C85.0187 255.23 84.616 255.359 84.203 255.359H76.6985C76.3142 255.36 75.9381 255.247 75.617 255.036C75.2959 254.825 75.0438 254.524 74.8921 254.171L71.5312 246.373",
    fill: "#699595"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8864 239.556L86.0705 254.015C85.9398 254.407 85.6891 254.747 85.3539 254.989C85.0187 255.23 84.616 255.359 84.203 255.359H76.6985C76.3142 255.36 75.9381 255.247 75.617 255.036C75.2959 254.825 75.0438 254.524 74.8921 254.171L71.5312 246.373",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.847 239.556L102.027 254.015C101.897 254.407 101.646 254.747 101.311 254.989C100.976 255.23 100.573 255.359 100.16 255.359H92.6477C92.2634 255.36 91.8874 255.247 91.5662 255.036C91.2451 254.825 90.9931 254.524 90.8413 254.171L87.4805 246.373",
    fill: "#699595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9845_20952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 239,
    width: 20,
    height: 17
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.847 239.556L102.027 254.015C101.897 254.407 101.646 254.747 101.311 254.989C100.976 255.23 100.573 255.359 100.16 255.359H92.6477C92.2634 255.36 91.8874 255.247 91.5662 255.036C91.2451 254.825 90.9931 254.524 90.8413 254.171L87.4805 246.373",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9845_20952)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M103.431 239.556L100.135 254.015C99.9521 254.817 99.4404 255.359 98.8599 255.359H93.7232C93.1885 255.359 92.7035 254.893 92.4896 254.171L89.2969 246.533",
    fill: "black"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M106.847 239.556L102.027 254.015C101.897 254.407 101.646 254.747 101.311 254.989C100.976 255.23 100.573 255.359 100.16 255.359H92.6477C92.2634 255.36 91.8874 255.247 91.5662 255.036C91.2451 254.825 90.9931 254.524 90.8413 254.171L87.4805 246.373",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0924 249.069C103.908 249.069 122.403 232.295 122.403 211.604C122.403 190.912 103.908 174.138 81.0924 174.138C58.2769 174.138 39.7812 190.912 39.7812 211.604C39.7812 232.295 58.2769 249.069 81.0924 249.069Z",
    fill: "#699595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9845_20952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 173,
    width: 84,
    height: 76
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8775 248.366C103.693 248.366 122.189 231.592 122.189 210.901C122.189 190.209 103.693 173.435 80.8775 173.435C58.062 173.435 39.5664 190.209 39.5664 210.901C39.5664 231.592 58.062 248.366 80.8775 248.366Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9845_20952)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M109.548 186.004C111.97 190.809 113.232 196.114 113.233 201.495C113.233 222.186 94.7371 238.96 71.9218 238.96C63.4315 239.003 55.1095 236.592 47.957 232.017C55.1598 241.683 67.3542 248.057 81.1831 248.057C103.334 248.057 121.284 231.784 121.284 211.707C121.261 201.659 116.777 192.581 109.548 186.004Z",
    fill: "#4A6868"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0924 249.069C103.908 249.069 122.403 232.295 122.403 211.604C122.403 190.912 103.908 174.138 81.0924 174.138C58.2769 174.138 39.7812 190.912 39.7812 211.604C39.7812 232.295 58.2769 249.069 81.0924 249.069Z",
    stroke: "#4A6868",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M118.925 214.964C118.024 222.511 114.544 229.359 109.305 234.766",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M118.242 203.343C118.852 205.871 119.159 208.461 119.159 211.061",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8477 176.476C74.2516 175.68 77.7361 175.28 81.2318 175.284C83.4698 175.284 85.7048 175.447 87.919 175.773",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1916 202.629C89.1916 202.629 93.2016 199.906 93.3467 194.895C93.4919 189.885 86.9001 182.582 81.603 179.573C76.306 176.564 72.4372 177.14 72.2959 179.287C72.1546 181.433 70.2909 183.87 69.5767 188.021C68.8625 192.172 68.5723 198.332 74.1596 200.337",
    fill: "#699595"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1916 202.629C89.1916 202.629 93.2016 199.906 93.3467 194.895C93.4919 189.885 86.9001 182.582 81.603 179.573C76.306 176.564 72.4372 177.14 72.2959 179.287C72.1546 181.433 70.2909 183.87 69.5767 188.021C68.8625 192.172 68.5723 198.332 74.1596 200.337",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.5698 201.021L81.3909 201.143C84.9121 201.651 86.1495 199.352 86.0464 195.9C85.9051 191.03 79.4623 180.719 76.7392 179.287C74.0162 177.854 73.1607 179.859 73.1607 179.859C73.1607 179.859 73.5427 180.115 72.2022 184.565C71.5835 186.619 69.2805 193.784 71.5605 196.961C73.577 199.768 77.3236 200.536 80.5698 201.021Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M91.9773 196.087H91.9238C91.8739 196.08 91.8257 196.064 91.782 196.039C91.7384 196.013 91.7003 195.98 91.6697 195.939C91.6392 195.899 91.6169 195.854 91.6041 195.805C91.5914 195.756 91.5884 195.705 91.5954 195.655C91.6368 195.362 91.661 195.066 91.668 194.769C91.7443 192.096 89.5636 188.258 85.9775 184.717C85.9417 184.682 85.9131 184.64 85.8935 184.594C85.8739 184.547 85.8636 184.497 85.8633 184.447C85.8629 184.397 85.8725 184.347 85.8914 184.3C85.9104 184.253 85.9383 184.211 85.9737 184.175C86.0091 184.139 86.0511 184.111 86.0975 184.091C86.1439 184.071 86.1937 184.061 86.2441 184.061C86.2944 184.06 86.3444 184.07 86.391 184.089C86.4377 184.108 86.4801 184.136 86.516 184.171C90.3045 187.914 92.5158 191.882 92.4318 194.788C92.4236 195.113 92.3981 195.437 92.3554 195.758C92.3425 195.849 92.2972 195.933 92.2277 195.993C92.1582 196.054 92.0693 196.087 91.9773 196.087Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.9223 200.693C89.85 200.693 89.7791 200.673 89.7179 200.634C89.6567 200.596 89.6077 200.541 89.5765 200.476C89.5453 200.41 89.5332 200.338 89.5417 200.266C89.5502 200.194 89.5789 200.126 89.6244 200.07C90.2538 199.299 90.7566 198.433 91.1138 197.504C91.1498 197.409 91.2219 197.332 91.3143 197.291C91.4067 197.249 91.5118 197.246 91.6065 197.282C91.7012 197.318 91.7777 197.39 91.8193 197.483C91.8608 197.575 91.864 197.68 91.828 197.775C91.4422 198.78 90.8981 199.718 90.2163 200.551C90.1808 200.595 90.136 200.631 90.0852 200.655C90.0343 200.679 89.9787 200.692 89.9223 200.693Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M62.109 218.853C63.2385 214.326 59.3015 209.445 53.3156 207.952C47.3296 206.458 41.5614 208.917 40.4319 213.444C39.3024 217.971 43.2393 222.851 49.2253 224.345C55.2112 225.838 60.9795 223.38 62.109 218.853Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5699 218.031C62.6994 213.504 58.7625 208.623 52.7765 207.13C46.7905 205.636 41.0223 208.095 39.8928 212.622C38.7633 217.149 42.7002 222.029 48.6862 223.523C54.6722 225.016 60.4404 222.557 61.5699 218.031Z",
    fill: "#699595",
    stroke: "#4A6868",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3642 213.96C47.4329 214.984 47.0395 215.847 46.4896 215.87C45.9396 215.893 45.4317 215.106 45.3439 214.082C45.256 213.059 45.6685 212.192 46.2222 212.173C46.776 212.154 47.2954 212.933 47.3642 213.96Z",
    fill: "#4A6868",
    stroke: "#4A6868",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9306 215.858C54.9993 216.886 54.6059 217.745 54.056 217.768C53.506 217.791 52.9981 217.004 52.9103 215.977C52.8224 214.949 53.2349 214.09 53.7886 214.067C54.3424 214.044 54.8504 214.831 54.9306 215.858Z",
    fill: "#4A6868",
    stroke: "#4A6868",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M67.422 218.512C67.3414 219.248 67.1695 219.97 66.9102 220.663C64.7181 226.586 56.782 229.149 48.9414 226.597",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1445 217.951H68.5773",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6436 202.094C50.3762 203.206 49.6926 204.004 49.1159 203.859C48.5393 203.713 48.2872 202.713 48.5584 201.59C48.8295 200.467 49.5093 199.681 50.086 199.822C50.6627 199.963 50.9147 200.979 50.6436 202.094Z",
    fill: "#699595",
    stroke: "#4A6868",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6866 203.63C57.9555 202.514 57.7063 201.497 57.1301 201.358C56.5539 201.22 55.8689 202.011 55.6 203.127C55.3312 204.242 55.5804 205.259 56.1566 205.398C56.7328 205.537 57.4178 204.745 57.6866 203.63Z",
    fill: "#699595",
    stroke: "#4A6868",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2031 244.207L72.4041 254.175C72.5549 254.532 72.8074 254.836 73.13 255.05C73.4526 255.264 73.8311 255.378 74.2182 255.378H81.8564C82.2399 255.378 82.615 255.265 82.9358 255.055C83.2566 254.845 83.5092 254.546 83.6628 254.194L88.2457 243.604H88.0471",
    fill: "#699595"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9845_20952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 243,
    width: 21,
    height: 13
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2031 244.207L72.4041 254.175C72.5549 254.532 72.8074 254.836 73.13 255.05C73.4526 255.264 73.8311 255.378 74.2182 255.378H81.8564C82.2399 255.378 82.615 255.265 82.9358 255.055C83.2566 254.845 83.5092 254.546 83.6628 254.194L88.2457 243.604H88.0471",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9845_20952)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M77.0784 242.935C74.6571 242.935 71.8386 243.252 69.5586 242.725L73.4846 254.156C73.5781 254.488 73.773 254.782 74.0422 254.998C74.3113 255.214 74.6411 255.34 74.9855 255.359H81.2794C81.6197 255.34 81.9457 255.216 82.2125 255.004C82.4793 254.792 82.6737 254.502 82.7688 254.175L86.5688 242.515L85.0412 242.725C80.1948 243.252 80.3208 242.935 77.0784 242.935Z",
    fill: "black"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2031 244.207L72.4041 254.175C72.5549 254.532 72.8074 254.836 73.13 255.05C73.4526 255.264 73.8311 255.378 74.2182 255.378H81.8564C82.2399 255.378 82.615 255.265 82.9358 255.055C83.2566 254.845 83.5092 254.546 83.6628 254.194L88.2457 243.604H88.0471",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1133 176.965L76.667 179.05L85.2829 176.965L93.345 155.842L88.0632 154.035L76.1133 176.965Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7489 148.895L90.6989 153.344L84.8633 179.746L70.8281 175.438L78.7489 148.895Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0586 174.148L84.5127 177.81L89.9319 154.323L79.0208 150.817L72.0586 174.148Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2081 156.338C77.6661 156.195 77.0997 156.169 76.5468 156.262L73.293 167.165C73.7639 167.624 74.3433 167.957 74.9772 168.132C77.5283 168.834 80.3239 166.761 81.2176 163.503C82.1113 160.245 80.7555 157.037 78.2081 156.338Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7496 158.145C77.7333 158.137 77.7199 158.125 77.7115 158.109C77.7032 158.093 77.7005 158.075 77.7038 158.057L77.8489 157.492C77.8578 157.468 77.8611 157.442 77.8587 157.417C77.8562 157.392 77.8481 157.367 77.8349 157.346C77.8216 157.324 77.8036 157.306 77.7823 157.292C77.7609 157.278 77.7367 157.269 77.7115 157.266L77.1042 157.121C77.0804 157.112 77.0547 157.108 77.0292 157.11C77.0036 157.112 76.9788 157.12 76.9569 157.133C76.935 157.147 76.9165 157.165 76.903 157.187C76.8894 157.208 76.8812 157.233 76.8789 157.259L76.7605 157.843C76.7561 157.86 76.7456 157.876 76.7309 157.886C76.7162 157.897 76.6983 157.902 76.6803 157.9C76.4733 157.879 76.2648 157.879 76.0578 157.9L74.9464 161.632C75.8134 162.533 77.1653 162.983 76.9858 163.74C76.8827 164.167 76.4932 164.503 75.8095 164.351C75.6666 164.332 75.5294 164.282 75.4074 164.205C75.2854 164.128 75.1813 164.026 75.1023 163.905C75.0233 163.785 74.9713 163.648 74.9496 163.506C74.928 163.363 74.9373 163.218 74.977 163.079L75.0114 162.926C75.0305 162.842 74.9808 162.773 74.8624 162.747L74.6295 162.689L73.9688 164.897C74.2341 165.138 74.5442 165.325 74.8815 165.447C74.8986 165.454 74.9126 165.468 74.921 165.484C74.9293 165.501 74.9316 165.52 74.9273 165.538L74.7899 166.023C74.7793 166.047 74.7747 166.073 74.7764 166.099C74.778 166.125 74.786 166.15 74.7995 166.172C74.813 166.194 74.8317 166.213 74.854 166.226C74.8762 166.24 74.9014 166.247 74.9273 166.249L75.5575 166.402C75.5796 166.413 75.6042 166.42 75.6293 166.421C75.6543 166.421 75.6793 166.417 75.7021 166.406C75.725 166.396 75.7452 166.38 75.7612 166.361C75.7771 166.342 75.7885 166.319 75.7943 166.295L75.8974 165.813C75.9031 165.796 75.9143 165.78 75.9294 165.769C75.9445 165.758 75.9627 165.752 75.9814 165.752C77.3257 165.894 78.2385 165.233 78.5211 164.057C78.7426 163.117 78.4256 162.319 77.4441 161.567C76.5466 160.887 75.5995 160.551 75.7637 159.856C75.8783 159.374 76.3175 159.153 76.9094 159.294C77.056 159.318 77.1956 159.373 77.3188 159.456C77.442 159.538 77.5458 159.647 77.6231 159.773C77.7004 159.9 77.7494 160.042 77.7666 160.189C77.7838 160.337 77.7689 160.486 77.7229 160.627L77.6962 160.734C77.6962 160.799 77.7344 160.856 77.8528 160.887L78.9718 161.154C78.9956 161.163 79.0211 161.166 79.0464 161.164C79.0717 161.161 79.0961 161.153 79.1178 161.14C79.1395 161.127 79.1579 161.109 79.1716 161.087C79.1853 161.066 79.1941 161.042 79.1971 161.017L79.2811 160.661C79.537 159.542 78.9985 158.592 77.7496 158.145Z",
    fill: "#699595"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4144 157.742L74.9187 147.722C74.282 146.562 74.9286 145.114 76.218 144.813L88.2367 142.01C89.4425 141.729 90.6115 142.6 90.6872 143.836L91.4152 155.736C91.4795 156.788 90.7167 157.709 89.6714 157.842L82.4204 158.765C81.6052 158.868 80.8096 158.463 80.4144 157.742Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 0.7
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9844 146.167L83.0087 158.173",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3828 144.756L86.208 157.359",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M89.082 143.948L89.6273 156.851",
    stroke: "#699595",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.5,
    cy: 260,
    rx: 55.5,
    ry: 5,
    fill: "#699595",
    fillOpacity: 0.22
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110.5C69.6667 112.833 85 114.8 93 104",
    stroke: "#699595",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3544 119.47C79.937 119.589 93.9294 116.66 97.2375 104",
    stroke: "#699595",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastImg);
export default __webpack_public_path__ + "static/media/lastImg.f3e7ebb8ca48508fa63677deaa21d03f.svg";
export { ForwardRef as ReactComponent };